import React from 'react';
import './App.css';
import './styles/main.scss';
import Canvas from './app/canvas/canvas';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Canvas />
      </header>
    </div>
  );
}

export default App;
